var BUTTONS_MYINFO = {
  setPhoto: {
    id: 'setPhoto',
    title: '我的头像设置',
    func: null,
    params: '我的头像设置'
  },
  changePhoneNo: {
    id: 'changePhoneNo',
    title: '更换账号',
    func: null,
    params: '更换账号'
  },
  changePwd: {
    id: 'changePwd',
    title: '修改密码',
    func: null,
    params: '修改密码'
  },
  checkVersion: {
    id: 'checkVersion',
    title: '版本更新检查',
    func: null,
    params: '版本更新检查'
  },
  about: {
    id: 'about',
    title: '关于',
    func: null,
    params: '关于'
  }
}

export { BUTTONS_MYINFO }
